import React from 'react';
import { useSiteVarsFunctions } from "../../hooks/use-site-vars-functions";

export const PlayerShirtImage = ({ player, teamId, positionId, style }) => {
  const { getTeamById, getPlayerPositionById } = useSiteVarsFunctions();

  let actualTeamId = teamId;
  let actualPositionId = positionId;

  if (player) {
    actualTeamId = player.teamId;
    actualPositionId = player.positionId;
  }

  if (!actualTeamId || !actualPositionId) {
    return null; // Or a placeholder image
  }

  const team = getTeamById(actualTeamId);
  const position = getPlayerPositionById(actualPositionId);

  if (!team || !position) {
    return null; // Or a placeholder image
  }

  const imageUrl = `https://fantasy.premierleague.com/dist/img/shirts/standard/shirt_${team.kitId}${position.name_short === "GKP" ? "_1" : ""}-66.webp`;

  return (
    <img 
      src={imageUrl} 
      alt="Player Shirt" 
      style={{ width: 40, height: 40, ...style }} 
    />
  );
};